module.exports = __webpack_public_path__ + "img/C2.5015cb47.jpg";